import {SignUp} from "aws-amplify-react"
import Amplify, {Auth} from "aws-amplify";
import '../App.css';
import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import {Core as YubinBangoCore} from 'yubinbango-core';
import SimpleReactValidator from 'simple-react-validator';
import { subYears } from 'date-fns';
import {SignUpComponents} from "../Components/SignUpComponents";
import APP_ENV from "../Environment";
import axios from "axios";
import TranslateError from "../translate/TranslateError";
import {err_logger} from "../Logics/logger";
import format from "date-fns/format";


export default class MySignUp extends SignUp {
    constructor() {
        super();
        this.state = {
            email: "",
            email_confirm: "",
            password: "",
            password_confirm: "",
            name01: "",
            name02: "",
            name03: "",
            kana01: "",
            kana02: "",
            birth: subYears(new Date(), 30),
            sex: "1",
            bloodtype: "",
            men_checked: false,
            women_checked: false,
            mailmaga_flg: "2",
            mailmaga_demand_checked: true,
            mailmaga_undemand_checked: false,
            zip: "",
            pref: "",
            addr01: "",
            addr02: "",
            addr03: "",
            tel: "",
            isSignUpDisable: false,
            blocking: false,
            keepInView: false,
            fetchUserAttributes: false,
            action_type: 'unconnected_oauth',
            cognito_user_attributes: {},
            mode: ""

        };
        this.handleInputChangeSignUp = this.handleInputChangeSignUp.bind(this);
        this.handleBirthChange = this.handleBirthChange.bind(this);
        this.handleZipChange = this.handleZipChange.bind(this);
        this.handleRadioClick = this.handleRadioClick.bind(this);
        this.handleRadioMailMagaClick = this.handleRadioMailMagaClick.bind(this);
        this.signUp_with_oauth = this.signUp_with_oauth.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.validator = new SimpleReactValidator(
            {
                autoForceUpdate: this,
                className: 'text-danger',
                messages: {
                    required: "入力必須項目です",
                    email: 'メール形式で入力してください',
                    integer: '数値で入力してください',
                },
                validators: {
                    blank_regex: {
                        message: '入力値に空白記号が含まれています',
                        rule: (val, params, validator) => {
                            return val.match(/\s/g) === null ? true : false
                        }
                    },
                    password_regex: {
                        message: 'パスワードは大文字英字A-Z、小文字英字a-z、数字0-9をそれぞれ1文字以上使用し、8文字以上で設定してください',
                        rule: (val, params, validator) => {
                            return validator.helpers.testRegex(val,/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,99}$/g)
                        }
                    },
                    password_confirm: {
                        message: '確認用のパスワードが違います',
                        rule: (val, params, validator) => {
                            if (val.password !== val.password_confirm) return false
                            else return true;
                        }
                    },
                    email_confirm: {
                        message: '確認用のメールアドレスが違います',
                        rule: (val, params, validator) => {
                            if (val.email !== val.email_confirm) return false
                            else return true;
                        }
                    },
                    post_code_confirm: {
                        message: '郵便番号形式のハイフン(-)付きで御入力下さい',
                        rule: (val, params, validator) => {
                            return validator.helpers.testRegex(val,/^\d{3}-\d{4}$/)
                        }

                    },
                    telephone_confirm: {
                        message: '電話番号形式のハイフン(-)付きで御入力下さい',
                        rule: (val, params, validator) => {
                            return validator.helpers.testRegex(val,/\d{2,4}-\d{2,4}-\d{4}/)
                        }

                    },
                    kana_confirm: {
                        message: 'フリガナを全角カタカナで御入力下さい',
                        rule: (val, params, validator) => {
                            const kana = val.kana01 + val.kana02
                            if (!kana) return;
                            console.warn("kana", val)
                            console.warn("kana01", val.kana01)
                            console.warn("kana02", val.kana02)
                            return validator.helpers.testRegex(kana,/^[ァ-ヶー]+$/u)
                        }
                    }
                }
            }
        );
    }

    componentDidUpdate(prevProps) {
        if (!this.state.fetchUserAttributes && prevProps.authState === 'signUp') {
            if (prevProps.authData && prevProps.authData.mode === 'wgs'){
                this.setState({mode: 'wgs'});
            }
            this.fetch_user_attributes(this.props.authData);
        }
    }

    fetch_user_attributes(authData) {

        if (this.props.authData && this.props.authData.action_type === 'connected_oauth') {
            this.setState({
                fetchUserAttributes: true,
                action_type: 'connected_oauth',
                cognito_user_attributes: this.props.authData.cognito_user_attributes
            });
            this.validator = new SimpleReactValidator(
                {
                    className: 'text-danger',
                    messages: {
                        required: "入力必須項目です",
                        email: 'メール形式で入力してください',
                        integer: '数値で入力してください',
                    },
                    validators: {
                        blank_regex: {
                            message: '入力値に空白記号が含まれています',
                            rule: (val, params, validator) => {
                                return val.match(/\s/g) === null ? true : false
                            }
                        },
                        password_regex: {
                            message: 'パスワードは大文字英字A-Z、小文字英字a-z、数字0-9をそれぞれ1文字以上使用し、8文字以上で設定してください',
                            rule: (val, params, validator) => {
                                return validator.helpers.testRegex(val,/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,99}$/g)
                            }
                        },
                        password_confirm: {
                            message: '確認用のパスワードが違います',
                            rule: (val, params, validator) => {
                                if (val.password !== val.password_confirm) return false
                                else return true;
                            }
                        },
                        post_code_confirm: {
                            message: '郵便番号形式のハイフン(-)付きで御入力下さい',
                            rule: (val, params, validator) => {
                                return validator.helpers.testRegex(val,/^\d{3}-\d{4}$/)
                            }

                        },
                        telephone_confirm: {
                            message: '電話番号形式のハイフン(-)付きで御入力下さい',
                            rule: (val, params, validator) => {
                                return validator.helpers.testRegex(val,/\d{2,4}-\d{2,4}-\d{4}/)
                            }

                        },
                        kana_confirm: {
                            message: 'フリガナを全角カタカナで御入力下さい',
                            rule: (val, params, validator) => {
                                const kana = val.kana01 + val.kana02
                                console.warn("kana", kana)
                                return validator.helpers.testRegex(kana,/^[ァ-ヶー]+$/u)
    
                            }
                        }
                    }
                }
            );
        } else if (this.props.authData && this.props.authData.action_type === 'connected_social_provider') {
            this.setState({
                fetchUserAttributes: true,
                action_type: 'connected_social_provider',
                cognito_user_attributes: this.props.authData.cognito_user_attributes
            });
            this.validator = new SimpleReactValidator(
                {
                    className: 'text-danger',
                    messages: {
                        required: "入力必須項目です",
                        email: 'メール形式で入力してください',
                        integer: '数値で入力してください',
                    },
                    validators: {
                        blank_regex: {
                            message: '入力値に空白記号が含まれています',
                            rule: (val, params, validator) => {
                                return val.match(/\s/g) === null ? true : false
                            }
                        },
                        password_regex: {
                            message: 'パスワードは大文字英字A-Z、小文字英字a-z、数字0-9をそれぞれ1文字以上使用し、8文字以上で設定してください',
                            rule: (val, params, validator) => {
                                return validator.helpers.testRegex(val,/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,99}$/g)
                            }
                        },
                        password_confirm: {
                            message: '確認用のパスワードが違います',
                            rule: (val, params, validator) => {
                                if (val.password !== val.password_confirm) return false
                                else return true;
                            }
                        },
                        post_code_confirm: {
                            message: '郵便番号形式のハイフン(-)付きで御入力下さい',
                            rule: (val, params, validator) => {
                                return validator.helpers.testRegex(val,/^\d{3}-\d{4}$/)
                            }

                        },
                        telephone_confirm: {
                            message: '電話番号形式のハイフン(-)付きで御入力下さい',
                            rule: (val, params, validator) => {
                                return validator.helpers.testRegex(val,/\d{2,4}-\d{2,4}-\d{4}/)
                            }

                        },
                        kana_confirm: {
                            message: 'フリガナを全角カタカナで御入力下さい',
                            rule: (val, params, validator) => {
                                const kana = val.kana01 + val.kana02
                                console.warn("kana", kana)
                                return validator.helpers.testRegex(kana,/^[ァ-ヶー]+$/u)
    
                            }
                        }
                    }
                }
            );

        } else {
            console.log("asdfasdf");
            this.setState({
                fetchUserAttributes: true,
                action_type: 'unconnected_oauth',
            });
            return;
        }

        const tmp_attributes_from_cognito = [];
        const attributes_from_cognito = authData.cognito_user_attributes;
        for (let key in attributes_from_cognito) {
            tmp_attributes_from_cognito[key] = attributes_from_cognito[key];
        }
        const attributes_fields = ["address", "birthdate", "gender", "cognito:username", "given_name", "family_name", "nickname", "email"];

        // signUp用の引数attributesを作成
        const user_attributes = [];
        for (let key in tmp_attributes_from_cognito) {
            if (attributes_fields.find((target_key) => key === target_key)) {
                user_attributes[key] = tmp_attributes_from_cognito[key]
            }
        }
        for (let key in user_attributes) {
            if (key === 'gender') {
                if (user_attributes[key] === "male") {
                    this.setState({
                        sex: "1",
                        men_checked: true,
                        women_checked: false
                    });
                } else if (user_attributes[key] === "female") {
                    this.setState({
                        sex: "2",
                        men_checked: false,
                        women_checked: true
                    });
                }

            } else if (key === 'birthdate') {
                this.setState({
                    birth: new Date(user_attributes[key])
                });
            } else if (key === 'address') {
                let address = user_attributes[key].replace(/\\/g, '');
                // cognitoのopenid_connectから取得したフォーマットを適切に変換する
                address = address.replace(/"{/g, '{');
                address = address.replace(/}"/g, '}');
                address = JSON.parse(address);
                const address_info = address.formatted;
                if (0 !== Object.keys(address_info).length) {
                    this.setAddressInfos(address_info);
                }
            }else if (key === 'family_name') {
                this.setState({
                    name01: user_attributes[key]
                });

            } else if (key === 'given_name') {
                this.setState({
                    name02: user_attributes[key]
                });

            } else if (key === 'nickname') {
                this.setState({
                    name03: user_attributes[key]
                });

            }
            else if (key === 'email') {
                this.setState({
                    email: user_attributes[key]
                });

            }
        }

    }

    setAddressInfos(address_info) {
        if (address_info) {
            const postal_code_str = address_info.postal_code;
            this.setState({
                zip: postal_code_str
            });
            try {
                new YubinBangoCore(postal_code_str, (addr) => {
                    let addr_from_street = address_info.street_address.replace(addr.street, '');
                    const allNumber = `([0-9０-９]+|[一二三四五六七八九十百千]+)`;
                    const address_nam_alys = addr_from_street.match(new RegExp(`${allNumber}+(${allNumber}|(番町|丁目|丁|番地|番|号|-|‐|–|ー|−|－|の))*(${allNumber}|(丁目|丁|番地|番|号))`, "g"));
                    let addr02 = "";
                    let addr03 = '';
                    if (address_nam_alys !== null) {
                        let addr02_num_str = "";
                        const len = address_nam_alys.length;
                        for (let i = 0; i < len; i++) {
                            const address = address_nam_alys[i];
                            if (address.length >= addr02_num_str.length) {
                                addr02_num_str = address;
                            }
                        }
                        const addr_first_num_index = addr_from_street.lastIndexOf(addr02_num_str);
                        addr02 = addr_from_street.substring(0, addr_first_num_index + addr02_num_str.length);
                        addr03 = addr_from_street.replace(addr02, '').trim();
                    }
                    this.setState({
                        addr01: addr.locality + addr.street,
                        addr02: addr02,
                        addr03: addr03,
                        pref: String(addr.region_id)
                    });
                })
            } catch (e) {
                console.error(e)
            }
        }
    }

    handleInputChangeSignUp (e) {
        this.setState({
            [e.target.name] : e.target.value
        });
    }
    handleBirthChange(date) {
        this.setState({
            birth: date
        });
    }
    handleZipChange(e) {
        let zip = "";
        if (e.target.name === "zip") {
            this.setState({
                zip: e.target.value
            });
            zip = e.target.value;
        }
        if (zip.length >= 7) {
            if (zip.search(/-/) !== -1) {
                zip = zip.replace(/-+/g, '');
            }
            try {
                new YubinBangoCore(zip, (addr) => {
                    this.setState({
                        addr01: addr.locality + addr.street,
                        pref: String(addr.region_id)
                    });
                })
            } catch (e) {
                console.error(e)
            }
        }
    }
    handleRadioClick(e) {
        if (e.target.name === "men") {
            this.setState({
                sex:  String(e.target.value),
                men_checked: true,
                women_checked: false
            });
        } else if(e.target.name === "women") {
            this.setState({
                sex:  String(e.target.value),
                men_checked: false,
                women_checked: true
            });
        }
    }

    handleRadioMailMagaClick(e) {
        if (e.target.name === "mailmaga_demand") {
            this.setState({
                mailmaga_flg: String(e.target.value),
                mailmaga_demand_checked: true,
                mailmaga_undemand_checked: false
            });
        } else if(e.target.name === "mailmaga_undemand") {
            this.setState({
                mailmaga_flg: String(e.target.value),
                mailmaga_demand_checked: false,
                mailmaga_undemand_checked: true
            });
        }
    }

    handleOnBlur(e) {
        const onValidUpdate = () => {
            this.validator.fieldValid(e.target.name)
            this.validator.showMessageFor(e.target.name);
        };
        onValidUpdate()
    }

    validate() {
        let err  = "";
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            window.scrollTo(0, 0);
            err = "入力誤りがあります。";
            this.forceUpdate();
        }
        return err;

    }
    display_err(err, translate = false) {
        window.scrollTo(0, 0);
        if (translate) {
            this.error(TranslateError(err))
        } else {
            this.error(err);
        }
    }
    get_post_user_param() {
        let tmp_attributes = {};
        let offline_attributes = {};
        let blood_attributes = {};

        // まず共通で必要な属性値をキーと値の形でオブジェクト化
        for (let key of Object.keys(this.state)) {
            tmp_attributes[key] = this.state[key];
        }
        const post_fields = ["email","name01", "name02", "name03", "kana01", "kana02", "birth", "zip", "pref", "addr01", "addr02", "addr03", "tel","mailmaga_flg","sex"];

        post_fields.forEach(key => {
            if (key === "email" && tmp_attributes[key] !== "") {
                offline_attributes[key] = tmp_attributes[key].toLowerCase()
            } else if (key === "birth" && tmp_attributes[key] !== "") {
                offline_attributes[key] = format(tmp_attributes[key], 'yyyy-MM-dd')
            } else if (key === "zip" && tmp_attributes[key] !== "") {
                const zips = tmp_attributes[key].split(/[-]/);
                offline_attributes["zip01"] = zips[0];
                offline_attributes["zip02"] = zips[1];
            } else if (key === "tel" && tmp_attributes[key] !== "") {
                const tels = tmp_attributes[key].split(/[-]/);
                offline_attributes["tel01"] = tels[0];
                offline_attributes["tel02"] = tels[1];
                offline_attributes["tel03"] = tels[2];
            } else if (tmp_attributes[key] !== "") {
                offline_attributes[key] = tmp_attributes[key]
            }
        });
        blood_attributes["bloodtype"] = tmp_attributes["bloodtype"];
        return {
            "user": {
                "password": this.state.password,
                offline_attributes,
                blood_attributes
            }
        }

    }
    signUp() {
        this.common_signup_process();

    }

    common_signup_process() {
        this.setState({
            isSignUpDisable: true,
            blocking: true,
            keepInView: true
        });
        window.scrollTo(window.scrollX, window.scrollY + 1);
        const err = this.validate();
        if (err !== "") {
            window.scrollTo(0, 0);
            this.display_err(err);
            this.setState({
                isSignUpDisable: false,
                blocking: false,
                keepInView: false
            });
            return;
        }
        const params = this.get_post_user_param();

        axios.post(APP_ENV.BFF + "/user", params)
            .then((res) => {
                if (this.state.action_type === 'connected_oauth') {
                    this.sign_up_with_oauth_only_process(res);
                } else {
                    this.sign_up_only_process(res);
                }
            })
            .catch((e) => {
                window.scrollTo(0, 0);
                this.setState({
                    isSignUpDisable: false,
                    blocking: false,
                    keepInView: false
                });
                // eslint-disable-next-line
                if (e == 'Error: Request failed with status code 409') {
                    this.display_err("入力されたメールアドレスはすでに登録されています 一度ログインし直してください");
                } else {
                    this.display_err("ユーザの登録に失敗しました");
                }
            });
    }

    sign_up_only_process(res) {
        const signup_info = this.get_signup_info(res.data);
        console.log("signup_info_mode" + this.state);
        console.log(this.state);
        Auth.signUp(signup_info).then((data) => {
            window.history.replaceState('', '', '/confirm_sign_up');
            this.changeState('confirmSignUp', {
                user: data.user,
                password: this.state.password,
                isInitialMessage: true,
                mode: this.state.mode
            });
        })
            .catch(err => {
                err_logger(signup_info.username, err, "signup_info", {signup_info});
                this.display_err(err, true);
            })
            .finally(() => {
                this.setState({
                    isSignUpDisable: false,
                    blocking: false,
                    keepInView: false
                });
            });
    }

    signUp_with_oauth() {
        this.common_signup_process()
    }

    sign_up_with_oauth_only_process(res) {
        const signup_info = this.get_admin_cognito_create_info(res.data);
        axios.post(APP_ENV.BFF + "/user/cognito-user",signup_info)
            .then((data) => {
                const email = this.state.email;
                const password = this.state.password;
                Amplify.Auth.signIn(email, password)
                    .then((user) => {
                        const axiosBase = require('axios');
                        const tmp_axios = axiosBase.create({
                            baseURL: APP_ENV.BFF,
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json',
                                'Authorization': `Bearer ${user.signInUserSession.idToken.jwtToken}`
                            },
                            responseType: 'json'
                        });
                        tmp_axios.post(APP_ENV.BFF + "/oauth", {cognito_user_attributes: this.state.cognito_user_attributes, sender: 'Entry'})
                            .then(() => {
                                window.history.replaceState('', '', '/');
                                this.changeState('CompOIDCSignUp');

                            })
                            .catch(err => {
                                window.scrollTo(0, 0);
                                this.setState({
                                    isSignUpDisable: false,
                                    blocking: false,
                                    keepInView: false
                                });
                                err_logger(this.state.email, err, "signup_info", {cognito_user_attributes: this.state.cognito_user_attributes});
                                this.display_err("ユーザの登録に失敗しました");
                            })
                    })
                    .catch(err => {
                        window.scrollTo(0, 0);
                        this.setState({
                            isSignUpDisable: false,
                            blocking: false,
                            keepInView: false
                        });
                        err_logger(this.state.email, err, "signup_info", {email, password});
                        this.display_err("ユーザの登録に失敗しました");

                    })
        })
            .catch(err => {
                err_logger(signup_info.username, err, "signup_info",{signup_info});
                this.display_err(err, true);
            })
            .finally(() => {
                this.setState({
                    isSignUpDisable: false,
                    blocking: false,
                    keepInView: false
                });
            });
    }

    get_signup_info(data) {
        let tmp_attributes = {};

        // まず共通で必要な属性値をキーと値の形でオブジェクト化
        for (let key of Object.keys(this.state)) {
            if (key === "email") {
                tmp_attributes[key] = this.state[key].toLowerCase();
            } else {
                tmp_attributes[key] = this.state[key];
            }
        };

        Object.assign(tmp_attributes, {
            locale: "ja",
            "custom:ecc_customer_id": String(data.customer_id)
        });
        const attributes = this.get_attributes(tmp_attributes);
        let signup_info = {
            username: this.state.email.toLowerCase(),
            password: this.state.password,
            attributes,
        };
        return signup_info;
    }

    get_admin_cognito_create_info(data) {
        let signup_info = {
            email: this.state.email.toLowerCase(),
            password: this.state.password,
            customer_id: data.customer_id,
        };
        return signup_info;
    }

    get_attributes(tmp_attributes) {
        let attributes = {};
        const attributes_fields = ["email","locale","custom:ecc_customer_id"];

        // signUp用の引数attributesを作成
        attributes_fields.forEach(key => attributes[key] = tmp_attributes[key]);
        return attributes;
    }

    showComponent(theme) {
        if (this.state.action_type === 'unconnected_oauth') {
            return this.sign_up_component_with_all_contents(theme);

        } else {
            return (
                this.sign_up_components_without_password_and_email(theme)
            );
        }
    }

    sign_up_components_without_password_and_email(theme) {
        return <SignUpComponents theme={theme} email={this.state.email}
                                 handleInputChangeSignUp={this.handleInputChangeSignUp}
                                 password={this.state.password}
                                 password_err_msg={this.validator.message('password', this.state.password, 'required|password_regex|blank_regex')}
                                 passwordConfirm={this.state.password_confirm}
                                 password_confirm_err_msg={this.validator.message('password_confirm', {
                                     password: this.state.password,
                                     password_confirm: this.state.password_confirm
                                 }, 'password_confirm')}
                                 name01={this.state.name01}
                                 name02={this.state.name02}
                                 name01_err_msg={this.validator.message('name01', this.state.name01, 'required')}
                                 name02_err_msg={this.validator.message('name02', this.state.name02, 'required')}
                                 kana01={this.state.kana01} kana02={this.state.kana02}
                                 kana01_err_msg={this.validator.message('kana01', this.state.kana01, 'required')}
                                 kana02_err_msg={this.validator.message('kana02', this.state.kana02, 'required')}
                                 kana_err_msg={this.validator.message('kana01', {kana01: this.state.kana01,kana02: this.state.kana02}, 'kana_confirm')}
                                 name03={this.state.name03}
                                 name03_err_msg={this.validator.message('name03', this.state.name03, 'required')}
                                 birth={this.state.birth} handleBirthChange={this.handleBirthChange}
                                 birth_err_msg={this.validator.message('birth', this.state.birth, 'required')}
                                 menChecked={this.state.men_checked} handleRadioClick={this.handleRadioClick}
                                 womenChecked={this.state.women_checked}
                                 mailmagaDemandChecked={this.state.mailmaga_demand_checked}
                                 handleRadioMailMagaClick={this.handleRadioMailMagaClick}
                                 bloodtype={this.state.bloodtype}
                                 bloodtype_err_msg={this.validator.message('bloodtype', this.state.bloodtype, 'required')}
                                 mailmagaUndemandChecked={this.state.mailmaga_undemand_checked}
                                 handleZipChange={this.handleZipChange} zip={this.state.zip}
                                 zip_err_msg={this.validator.message('zip', this.state.zip, 'required|post_code_confirm')}
                                 pref={this.state.pref} callbackfn={prefacture =>
            <option key={prefacture.code} value={prefacture.code}>
                {prefacture.name}
            </option>} addr01={this.state.addr01}
                                 addr01_err_msg={this.validator.message('addr01', this.state.addr01, 'required')}
                                 addr02={this.state.addr02}
                                 addr02_err_msg={this.validator.message('addr02', this.state.addr02, 'required')}
                                 addr03={this.state.addr03} tel={this.state.tel}
                                 tel_err_msg={this.validator.message('tel', this.state.tel, 'required|telephone_confirm')}
                                 signUp={this.signUp} changeStateFunc={() => {
            window.history.replaceState('', '', '/');
            this.changeState('signIn',{display_screen: true})
        }}
                                 isSignUpDisable={this.state.isSignUpDisable}
                                 blocking={this.state.blocking}
                                 keepInView={this.state.keepInView}
                                 action_type={this.state.action_type}
                                 handleOnBlur={this.handleOnBlur}
        />;
    }

    sign_up_component_with_all_contents(theme) {
        return (
            <SignUpComponents theme={theme} email={this.state.email}
                              handleInputChangeSignUp={this.handleInputChangeSignUp}
                              email_err_msg={this.validator.message('email', this.state.email, 'required|blank_regex|email')}
                              emailConfirm={this.state.email_confirm}
                              email_confirm_err_msg={this.validator.message('email_confirm', {
                                  email: this.state.email,
                                  email_confirm: this.state.email_confirm
                              }, 'email_confirm')}
                              password={this.state.password}
                              password_err_msg={this.validator.message('password', this.state.password, 'required|password_regex|blank_regex')}
                              passwordConfirm={this.state.password_confirm} name01={this.state.name01}
                              password_confirm_err_msg={this.validator.message('password_confirm', {
                                  password: this.state.password,
                                  password_confirm: this.state.password_confirm
                              }, 'password_confirm')}
                              name02={this.state.name02}
                              name01_err_msg={this.validator.message('name01', this.state.name01, 'required')}
                              name02_err_msg={this.validator.message('name02', this.state.name02, 'required')}
                              kana01={this.state.kana01} kana02={this.state.kana02}
                              kana01_err_msg={this.validator.message('kana01', this.state.kana01, 'required')}
                              kana02_err_msg={this.validator.message('kana02', this.state.kana02, 'required')}
                              kana_err_msg={this.validator.message('kana01', {kana01: this.state.kana01,kana02: this.state.kana02}, 'kana_confirm')}
                              name03={this.state.name03}
                              name03_err_msg={this.validator.message('name03', this.state.name03, 'required')}
                              birth={this.state.birth} handleBirthChange={this.handleBirthChange}
                              birth_err_msg={this.validator.message('birth', this.state.birth, 'required')}
                              menChecked={this.state.men_checked} handleRadioClick={this.handleRadioClick}
                              womenChecked={this.state.women_checked}
                              mailmagaDemandChecked={this.state.mailmaga_demand_checked}
                              handleRadioMailMagaClick={this.handleRadioMailMagaClick}
                              bloodtype={this.state.bloodtype}
                              bloodtype_err_msg={this.validator.message('bloodtype', this.state.bloodtype, 'required')}
                              mailmagaUndemandChecked={this.state.mailmaga_undemand_checked}
                              handleZipChange={this.handleZipChange} zip={this.state.zip}
                              zip_err_msg={this.validator.message('zip', this.state.zip, 'required|post_code_confirm')}
                              pref={this.state.pref} callbackfn={prefacture =>
                <option key={prefacture.code} value={prefacture.code}>
                    {prefacture.name}
                </option>} addr01={this.state.addr01}
                              addr01_err_msg={this.validator.message('addr01', this.state.addr01, 'required')}
                              addr02={this.state.addr02}
                              addr02_err_msg={this.validator.message('addr02', this.state.addr02, 'required')}
                              addr03={this.state.addr03} tel={this.state.tel}
                              tel_err_msg={this.validator.message('tel', this.state.tel, 'required|telephone_confirm')}
                              signUp={this.signUp} changeStateFunc={() => {
                window.history.replaceState('', '', '/');
                this.changeState('signIn',{display_screen: true})
            }}
                              isSignUpDisable={this.state.isSignUpDisable}
                              blocking={this.state.blocking}
                              keepInView={this.state.keepInView}
                              action_type={this.state.action_type}
                              mode={this.state.mode}
                              handleOnBlur={this.handleOnBlur}
            />
        );
    }
}
